/* 包含 n 个接口请求函数的模块
  每个函数返回的都是 promise 对象
*/
import ajax from './ajax'
const BASE_URL = '/api'
// const BASE_URL = 'http://127.0.0.1:60850/api'
// 1、获取系统设置
export const systemSettingFindDetail = (id) => ajax(`${BASE_URL}/systemSetting/find_detail?code=${id}`, {}, 'POST')
// 1、获取普通版注册
export const reqRegister = (data) => ajax(`${BASE_URL}/member/register`, data, 'POST')
// 1、获取商家版注册
export const reqMerchantRegister = (data) => ajax(`${BASE_URL}/member/merchantRegister`, data, 'POST')
// 3、登录
export const reqLogin = (data) => ajax(`${BASE_URL}/member/login${data}`, {}, 'POST')
// 3、退出登录
export const reqLogout = (data) => ajax(`${BASE_URL}/member/outLogin`, data, 'POST')
// 2、获取验证码
export const reqCode = () => ajax(`${BASE_URL}/pictureCode/out`)
// 2、发送验证码
export const reqSend = (data) => ajax(`${BASE_URL}/code/send${data}`, {}, 'POST')
// 2、忘记密码
export const reqResetPwd = (data) => ajax(`${BASE_URL}/member/resetPwd${data}`, {}, 'POST')
// 1、获取注册商家选项
export const reqMerchant = () => ajax(`${BASE_URL}/systemSetting/merchantOption`)
// 1、获取首页的轮播图
export const reqCarousel = (type) => ajax(`${BASE_URL}/systemCarousel/getInfo?type=${type}`)
// 1、获取首页的全部订单
export const reqAllOrder = (data) => ajax(`${BASE_URL}/orderBase/getInfo`, data, 'POST')
// 1、获取全国订单的详情
export const reqDomesticOrderDetail = (id) => ajax(`${BASE_URL}/orderDomestic/find_detail?id=${id}`, {}, 'POST')
// 1、获取同城订单的详情
export const reqCityOrderDetail = (id) => ajax(`${BASE_URL}/orderCity/find_detail?id=${id}`, {}, 'POST')
// 1、获取医疗订单的详情n
export const reqDoctorOrderDetail = (id) => ajax(`${BASE_URL}/orderDoctor/find_detail?id=${id}`, {}, 'POST')
// 1、获取票务订单的详情
export const reqTicketOrderDetail = (id) => ajax(`${BASE_URL}/orderTicket/find_detail?id=${id}`, {}, 'POST')
// 1、获取其他订单的详情
export const reqOtherOrderDetail = (id) => ajax(`${BASE_URL}/orderOther/find_detail?id=${id}`, {}, 'POST')
// 1、获取历史记录地址
export const reqPastAddress = (data) => ajax(`${BASE_URL}/pastAddress/page`, data, 'POST')
// 1、计算同城价格
export const reqCountCityExpressFee = (data) => ajax(`${BASE_URL}/systemSetting/countCityExpressFee${data}`, {}, 'POST')
// 1、计算国内价格
export const reqCountStateExpressFee = (data) => ajax(`${BASE_URL}/systemSetting/countStateExpressFee${data}`, {}, 'POST')
// 1、获取同城快递提交订单
export const reqOrderCity = (data) => ajax(`${BASE_URL}/orderCity/submit`, data, 'POST')
// 1、获取国内快递提交订单
export const reqOrderDomestic = (data) => ajax(`${BASE_URL}/orderDomestic/submit`, data, 'POST')
// 1、获取出行方式
export const reqTravelWay = () => ajax(`${BASE_URL}/travelType/getInfo`)
// 1、获取座次类型
export const reqSeatType = (type) => ajax(`${BASE_URL}/seatType/getInfo?type=${type}`)
// 1、获取联系我们
export const reqAbout = () => ajax(`${BASE_URL}/systemCarousel/info`)
// 1、添加加盟成员
export const reqLeague = (data) => ajax(`${BASE_URL}/alliance/change`, data, 'POST')
// 1、获取医院接口
export const reqHospital = (data) => ajax(`${BASE_URL}/hospital/page`, data, 'POST')
// 1、获取医院详情
export const reqHospitalInfo = (id) => ajax(`${BASE_URL}/hospital/info?id=${id}`)
// 1、获取医生列表
export const reqDoctor = (data) => ajax(`${BASE_URL}/doctor/page`, data, 'POST')
export const reqAllDoctor = (data) => ajax(`${BASE_URL}/doctor/all`, data, 'POST')
// 1、获取医生详情
export const reqDoctorDetail = (id) => ajax(`${BASE_URL}/doctor/details?id=${id}`, {}, 'POST')
// 1、获取医疗计算价格
export const reqCountServeFee = (id) => ajax(`${BASE_URL}/doctor/countServeFee${id}`, {}, 'POST')
// 1、提交医疗订单
export const reqOrderDoctor = (data) => ajax(`${BASE_URL}/orderDoctor/submit`, data, 'POST')
// 1、计算票务价格和溢价
export const reqCountServiceFee = (id) => ajax(`${BASE_URL}/seatType/countServiceFee${id}`, {}, 'POST')
// 1、获取票务提交订单
export const reqOrderTicket = (data) => ajax(`${BASE_URL}/orderTicket/submit`, data, 'POST')
// 1、提交其他订单
export const reqOrderOther = (data) => ajax(`${BASE_URL}/orderOther/submit`, data, 'POST')
// 1、取消订单
export const reqCancelOrder = (id) => ajax(`${BASE_URL}/orderBase/cancelOrder?id=${id}`, {}, 'POST')
// 1、获取用户信息
export const reqUserInfo = () => ajax(`${BASE_URL}/member/details`)
// 1、修改个人信息
export const reqChangeUserInfo = (data) => ajax(`${BASE_URL}/member/changeInfo`, data, 'POST')
// 1、修改手机号
export const reqChangeMobile = (data) => ajax(`${BASE_URL}/member/changeMobile${data}`, {}, 'POST')
// 1、获取用户优惠券
export const reqCoupon = (data) => ajax(`${BASE_URL}/couponUser/page`, data, 'POST')
// 1、获取详情明细分页数据
export const reqMemberAccountTrade = (data) => ajax(`${BASE_URL}/memberAccountTrade/page`, data, 'POST')
// 1、获取银行列表
export const reqBankList = (data) => ajax(`${BASE_URL}/systemDictionary/getListByType?type=${data}`)
// 1、提现
export const reqWithdraw = (data) => ajax(`${BASE_URL}/memberAccount/withdraw`, data, 'POST')
// 1、修改支付密码
export const reqChangePayPwd = (data) => ajax(`${BASE_URL}/memberAccount/changePayPwd${data}`, {}, 'POST')
// 1、订单充值
export const reqRecharge = (data) => ajax(`${BASE_URL}/orderBase/recharge${data}`, {}, 'POST')
// 1、获取我的就诊人
export const reqPatient = (data) => ajax(`${BASE_URL}/patient/page`, data, 'POST')
// 1、添加和修改我的就诊人
export const reqPatientChange = (data) => ajax(`${BASE_URL}/patient/change`, data, 'POST')
// 1、删除患者信息
export const reqPatientDel = (id) => ajax(`${BASE_URL}/patient/delete?id=${id}`, {}, 'POST')
// 1、获取患者信息详情
export const reqPatientInfo = (id) => ajax(`${BASE_URL}/patient/info?id=${id}`)
// 1、获取我的乘客
export const reqPassenger = () => ajax(`${BASE_URL}/passenger/page`, {}, 'POST')
// 1、获取我的乘客详情
export const reqPassengerDetail = (id) => ajax(`${BASE_URL}/passenger/find_detail?id=${id}`, {}, 'POST')
// 1、添加或编辑我的乘客
export const reqPassengerChange = (data) => ajax(`${BASE_URL}/passenger/change`, data, 'POST')
// 1、删除我的乘客
export const reqPassengerDel = (id) => ajax(`${BASE_URL}/passenger/delete?id=${id}`, {}, 'POST')
// 1、获取发票列表
export const reqInvoice = () => ajax(`${BASE_URL}/invoice/page`, {}, 'POST')
// 1、获取发票详情
export const reqInvoiceDetail = (id) => ajax(`${BASE_URL}/invoice/detail?id=${id}`)
// 1、获取发票的确认收货
export const reqConfirmInvoice = (id) => ajax(`${BASE_URL}/invoice/confirmInvoice?invoiceId=${id}`, {}, 'POST')
// 1、取消发票,返回可开发票总额度
export const reqCancelInvoice = (id) => ajax(`${BASE_URL}/invoice/cancelInvoice?invoiceId=${id}`, {}, 'POST')
// 1、获取注册快递选项
export const reqExpress = () => ajax(`${BASE_URL}/systemSetting/express`)
// 1、申请发票
export const reqApply = (data) => ajax(`${BASE_URL}/invoice/apply`, data, 'POST')
// 1、获取用户地址信息
export const reqAddress = () => ajax(`${BASE_URL}/address/getInfo`, {}, 'POST')
// 1、添加或修改地址信息
export const reqChangeAddress = (data) => ajax(`${BASE_URL}/address/changeInfo`, data, 'POST')
// 1、删除地址信息
export const reqDelAddress = (id) => ajax(`${BASE_URL}/address/delete?id=${id}`, {}, 'POST')
// 1、余额支付
export const reqBalancePay = (id) => ajax(`${BASE_URL}/orderBase/balancePay${id}`, {}, 'POST')
// 1、微信支付
export const reqWechatPay = (id) => ajax(`${BASE_URL}/WeCharPay/prepay${id}`, {}, 'POST')
// 1、支付宝支付
export const reqAliPay = (id) => ajax(`${BASE_URL}/AliPay/prepay${id}`, {}, 'POST')
// 1、升级为商户
export const reqMerchantUpgrade = (data) => ajax(`${BASE_URL}/member/merchantUpgrade`, data, 'POST')
// 1、上传图片
export const reqFileUpload = (data) => ajax(`/errands/file/upload.do`, data, 'POST')
// export const reqFileUpload = (data) => ajax(`http://127.0.0.1:8093/errands/file/upload.do`, data, 'POST')
// 1、成为员工
export const reqPreparesStaff = (data) => ajax(`${BASE_URL}/preparesStaff/change`, data, 'POST')
// 1、获取投诉类型
export const reqComplaintType = () => ajax(`${BASE_URL}/complaint/complaintType`, {}, 'POST')
// 1、提交投诉信息
export const reqComplaint = (data) => ajax(`${BASE_URL}/complaint/add`, data, 'POST')
// 1、评论订单
export const reqEvaluate = (data) => ajax(`${BASE_URL}/orderBase/evaluate`, data, 'POST')
// 1、富文本
export const reqFullText = (code) => ajax(`${BASE_URL}/fullText/find_detail?code=${code}`, {}, 'POST')
// 获取我的消息列表
export const reqMessageSub = (code) => ajax(`${BASE_URL}/messageSub/page`, {}, 'POST')
// 快递员详情
export const reqFindDetail = (id) => ajax(`${BASE_URL}/courier/find_detail?orderId=${id}`, {}, 'POST')
// 快递员详情
export const reqOrderquery = (id) => ajax(`${BASE_URL}/WeCharPay/resPay${id}`, {}, 'POST')
// 获取追加价格
export const getAdditionalOrder = (id) => ajax(`${BASE_URL}/orderBase/getAdditionalOrder?id=${id}`, {}, 'POST')
// 获取首页介绍公司公司介绍模块
export const getCoverInfo = (id) => ajax(`${BASE_URL}/cover/getInfo?type=${id}`)

export const getTextInfo = () => ajax(`${BASE_URL}/fullText/getTextInfo`)



// WEBPACK FOOTER //
// ./src/api/index.js